// TODO: Consider removing this file and use the ServiceRequestModel instead
// there are other utils/configs that should be moved to the ServiceRequestModel as well but this is a bigger refactor

import { Icons } from '@commenda/kakashi';
import { TaskStatus } from '@prisma/client';

export const ServiceRequestTaskLabelConfig: Record<
  TaskStatus,
  string | null
> = {
  [TaskStatus.BACKLOG]: null,
  [TaskStatus.TO_DO]: null,
  [TaskStatus.IN_PROGRESS]: 'Last edited: ',
  [TaskStatus.COMPLETED]: 'Completed: ',
  [TaskStatus.CANCELED]: null,
};

export const ServiceRequestTaskIconConfig: Record<
  TaskStatus,
  React.ReactNode | null
> = {
  [TaskStatus.BACKLOG]: null,
  [TaskStatus.TO_DO]: null,
  [TaskStatus.IN_PROGRESS]: (
    <div className="size-6 bg-bg-warning flex justify-center items-center rounded-md mr-md">
      <Icons.Hourglass01 className="text-fg-warning size-4" />
    </div>
  ),
  [TaskStatus.COMPLETED]: (
    <div className="size-6 bg-bg-success flex justify-center items-center rounded-md mr-md">
      <Icons.CheckCircle className="text-text-success size-4" />
    </div>
  ),
  [TaskStatus.CANCELED]: null,
};
